export default function ServerConfig() {
  const configs = [
    { icon: 'ri-time-line', label: 'Horário oficial', value: 'Brasília (BRT)' },
    { icon: 'ri-flag-line', label: 'Largada', value: 'Parada' },
    { icon: 'ri-settings-3-line', label: 'Setup', value: 'Aberto' },
    { icon: 'ri-alert-line', label: 'Danos', value: 'Totais' },
    { icon: 'ri-shield-check-line', label: 'Assistências permitidas', value: 'TC e ABS' },
    { icon: 'ri-police-car-line', label: 'Safety Car', value: 'Apenas se necessário' },
    { icon: 'ri-gas-station-line', label: 'Pit stop', value: 'Não obrigatório' },
    { icon: 'ri-drop-line', label: 'Consumo', value: 'Real' },
    { icon: 'ri-cloudy-line', label: 'Clima', value: 'Dinâmico' }
  ];

  return (
    <section id="configuracoes" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Configurações Oficiais do Servidor
          </h2>
        </div>

        {/* Configurações Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {configs.map((config, index) => (
            <div key={index} className="bg-gray-50 p-6 rounded-xl border-2 border-gray-200 hover:border-orange-500 transition-all duration-300">
              <div className="flex items-start">
                <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-lg mr-4 flex-shrink-0">
                  <i className={`${config.icon} text-xl text-white`}></i>
                </div>
                <div>
                  <p className="text-sm text-gray-600 mb-1">{config.label}</p>
                  <p className="text-lg font-bold text-gray-900">{config.value}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Penalidades */}
        <div className="bg-gray-900 text-white p-8 rounded-xl mb-12">
          <div className="flex items-center mb-6">
            <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-lg mr-4">
              <i className="ri-scales-line text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold">Sistema de Penalidades</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start">
              <i className="ri-computer-line text-orange-500 text-2xl mr-4 mt-1"></i>
              <div>
                <p className="text-lg font-semibold mb-2">Sistema do Simulador</p>
                <p className="text-gray-300">Penalidades automáticas aplicadas durante a corrida</p>
              </div>
            </div>
            <div className="flex items-start">
              <i className="ri-file-warning-line text-orange-500 text-2xl mr-4 mt-1"></i>
              <div>
                <p className="text-lg font-semibold mb-2">Sistema de Protesto</p>
                <p className="text-gray-300">Protestos serão tratados pela organização</p>
              </div>
            </div>
          </div>
        </div>

        {/* Pontuação */}
        <div className="bg-orange-500/10 border-l-4 border-orange-500 p-8 rounded-lg">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Pontuação do Campeonato</h3>
          <ul className="space-y-3">
            <li className="flex items-start">
              <i className="ri-trophy-line text-orange-500 text-xl mr-3 mt-1"></i>
              <span className="text-base text-gray-700">Sistema de pontuação completo descrito no <strong>Regulamento Oficial</strong> disponível no grupo do campeonato</span>
            </li>
            <li className="flex items-start">
              <i className="ri-delete-bin-line text-orange-500 text-xl mr-3 mt-1"></i>
              <span className="text-base text-gray-700"><strong>Descarte:</strong> descarta a etapa de menor pontuação</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
